import { render, staticRenderFns } from "./PlatformSelector.vue?vue&type=template&id=c247fcfa&scoped=true"
import script from "./PlatformSelector.vue?vue&type=script&lang=js"
export * from "./PlatformSelector.vue?vue&type=script&lang=js"
import style0 from "./PlatformSelector.vue?vue&type=style&index=0&id=c247fcfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c247fcfa",
  null
  
)

export default component.exports